import { createFileRoute } from "@tanstack/react-router";
import { css } from "../../../../../styled-system/css";
import {
  useGetHokkaidoR8HouseholderPaperVouchersByPeriod,
  useGetHokkaidoR8HouseholderPostalReturnsByPeriod,
} from "../../../../libs/admin/hooks";
import {
  buildPeriodFilename,
  downloadBlobFile,
  downloadCsvFile,
} from "../../../../libs/utils/csv";
import { contentWrapper } from "../../../../styles/contentWrapper";
import { pageTitle, titleWrapper } from "../../../../styles/sectionStyles";
import { ExportSection } from "../-components/export-section";
import { buildPaperVoucherCsv, buildPostalReturnZip } from "./-csv/export-csv";

export const Route = createFileRoute("/admin/hokkaido/exports/")({
  component: RouteComponent,
});

function RouteComponent() {
  const paperVoucherMutation = useGetHokkaidoR8HouseholderPaperVouchersByPeriod();
  const postalReturnMutation = useGetHokkaidoR8HouseholderPostalReturnsByPeriod();

  return (
    <div className={contentWrapper()}>
      <div className={titleWrapper()}>
        <h1 className={pageTitle()}>CSV出力</h1>
      </div>
      <div className={css({ display: "flex", flexDirection: "column", gap: "24px" })}>
        <ExportSection
          title="ギフト券交付 CSV出力"
          description="指定期間内にギフト券交付済みとして登録された世帯主を出力します。"
          isPending={paperVoucherMutation.isPending}
          run={async (start, end) => {
            const rows = await paperVoucherMutation.mutateAsync({ start, end });
            const csv = buildPaperVoucherCsv(rows);
            return {
              count: rows.length,
              download: () =>
                downloadCsvFile(
                  buildPeriodFilename("paper_vouchers", start, end, "csv"),
                  csv,
                ),
            };
          }}
        />
        <ExportSection
          title="ハガキ返戻 CSV出力"
          description="指定期間内に返戻済みとして登録された世帯主を市区町村ごとのCSVに分けてzipで出力します（同一シリアルナンバーは期間内で最新の返戻1件）。"
          isPending={postalReturnMutation.isPending}
          run={async (start, end) => {
            const rows = await postalReturnMutation.mutateAsync({ start, end });
            const zip = await buildPostalReturnZip(rows, start, end);
            return {
              count: rows.length,
              download: () =>
                downloadBlobFile(
                  buildPeriodFilename("postal_returns", start, end, "zip"),
                  zip,
                ),
            };
          }}
        />
      </div>
    </div>
  );
}
